import React from "react";
import ChooseImg from "../../assets/img/about-us/why_choose_us.jpeg";
const ChoosingUS = () => {
    return (
    
        <div className="container p-5 my-4">
          <div className="row ">
            {/* Text Content */}
            <div className="col-md-6 text-dark ">
              <h5 className="display-6 pb-2 mb-4">
                Why Choose Us
              </h5>
              <p>
              Marketplace often feels aloft. We want a marketplace that allows communication and exchange of information resulting in transactions that reflect the true price of the car, 
              regardless whether you are a buyer or a seller. 
              And we are more than happy to hear your feedback and make the experience better for everyone.
              </p>
            </div>
            {/* Image Content */}
            <div className="col-md-6 text-center">
              <img
                src={ChooseImg}
                alt="Car Marketplace"
                className="img-fluid rounded shadow-lg"
                style={{ maxWidth: "100%", height: "auto" }}
              />
            </div>
          </div>
          </div>
        
      
    );
  };
  
  export default ChoosingUS;